import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'

import { SIGN_IN as signIn, setProjectId } from '../store/auth/actions'
import { makeStyles } from '@material-ui/core/styles'

import LoginLoadingView from '../components/view/LoginLoadingView'
import bgImage from '../assets/bg.png'

const useStyles = makeStyles(theme => ({
  container: {
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    boxSizing: 'border-box',
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: 'repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    height: '100%',
    background: '#E8E8E8'
  }
}))

export const LoginPage = ({ signIn, setProjectId }) => {
  const location = useLocation()
  const history = useHistory()
  React.useEffect(() => {
    const queryString = 'token'
    const queryProjectId = 'project_id'
    const queryparams = new URLSearchParams(location.search)
    const projectId = queryparams.get(queryProjectId)
    if (queryparams.has(queryString)) {
      signIn({
        ...(queryparams.has(queryProjectId) ? { project_id: projectId } : {}),
        token: queryparams.get(queryString),
        history
      })
    }
    if (projectId) {
      setProjectId(projectId)
    }
  }, [])
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <LoginLoadingView />
    </div>
  )
}

LoginPage.propTypes = {
  signIn: PropTypes.func.isRequired,
  setProjectId: PropTypes.func
}

LoginPage.defaultProps = {
  loginValues: undefined
}

const mapStateToProps = () => ({})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      signIn,
      setProjectId
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(LoginPage)
